var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cloud-arrow-up-fill",
    d: "M8,2A5.53,5.53,0,0,0,4.406,3.342,4.206,4.206,0,0,0,2.942,5.725,3.675,3.675,0,0,0,3.781,13h8.906a3.223,3.223,0,0,0,.479-6.421A5.136,5.136,0,0,0,8,2Zm2.354,5.146a.5.5,0,0,1-.708.708L8.5,6.707V10.5a.5.5,0,0,1-1,0V6.707L6.354,7.854a.5.5,0,0,1-.708-.708l2-2a.5.5,0,0,1,.708,0Z",
    transform: "translate(0 -2)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudUpload);
export default __webpack_public_path__ + "static/media/ic_cloud_upload.2cdacb3508dd22c1121683c5413dc810.svg";
export { ForwardRef as ReactComponent };